import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    TextField,
    Typography,
    Box,
    MenuItem,
    Grid,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UploadFile } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { returnOrder } from "../../State/Order/Action";

export default function ReturnExchangePopup({ open, onClose, orderId }) {
    const [reason, setReason] = useState(" ");          // Dropdown value
    const [otherReason, setOtherReason] = useState("");          // Dropdown value
    const [images, setImages] = useState([]);          // Selected images
    const [previewImages, setPreviewImages] = useState([]); // Preview URLs
    const dispatch = useDispatch();
    const { order } = useSelector((store) => store);


    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);

        const combinedFiles = [...images, ...files];

        // const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        // if (!allowedTypes.includes(combinedFiles.type)) {
        //     toast.error("Only JPG, JPEG, and PNG image are allowed!");
        //     return;
        // }

        if (combinedFiles.length > 5) {
            toast.error("Maximum 5 images allowed");
            return;
        }

        setImages(combinedFiles);

        // Update preview URLs
        const previews = combinedFiles.map(file => URL.createObjectURL(file));
        setPreviewImages(previews);
    };


    const handleRemoveImage = (index) => {
        const newImages = [...images];
        const newPreviews = [...previewImages];

        newImages.splice(index, 1);   // remove File
        newPreviews.splice(index, 1); // remove preview URL

        setImages(newImages);
        setPreviewImages(newPreviews);
    };


    const handleSubmit = async () => {
        if (!reason.trim()) {
            toast.error("Please select return reason");
            return;
        }
        if (images.length < 2) {
            toast.error("Please upload at least 2 images");
            return;
        }
        // FormData object create karo
        const formData = new FormData();
        formData.append("reason", reason); // string
        formData.append("otherReason", otherReason); // string

        // multiple images add karna
        images.forEach((file) => {
            formData.append("images", file); // same key "images"
        });

        dispatch(returnOrder(orderId, formData, handleCancle));
    };

    const handleCancle = () => {
        setReason(" ");
        setImages([]);
        setPreviewImages([]);
        onClose();
        setOtherReason("")
    }


    return (
        <Dialog open={open} onClose={handleCancle} maxWidth="sm" fullWidth>
            {/* Title with Close Button */}
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                Return Your Product
                <IconButton onClick={handleCancle}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {/* Content */}
            <DialogContent dividers sx={{ position: "relative", p: 3 }}>
                {/* Heading */}
                <Typography variant="body2" color="text.secondary" mb={3} textAlign="center">
                    Select the reason for return and upload supporting images (min 2, max 5)
                </Typography>

                {/* Dropdown */}
                <Box mb={2}>
                    <TextField
                        select
                        size="small"
                        fullWidth
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        label="Select Return Reason"
                    >
                        <MenuItem value=" " disabled>
                            Please select Return Reason...
                        </MenuItem>

                        {/* Generic options applicable for all product types */}
                        <MenuItem value="Damaged Product">Damaged Product</MenuItem>
                        <MenuItem value="Defective Item">Defective Item</MenuItem>
                        <MenuItem value="Wrong Item Delivered">Wrong Item Delivered</MenuItem>
                        <MenuItem value="Product Not As Described">Product Not As Described</MenuItem>
                        <MenuItem value="Late Delivery">Late Delivery</MenuItem>
                        <MenuItem value="Poor Quality">Poor Quality</MenuItem>

                        {/* Always keep "Other" at the end */}
                        <MenuItem value="Other">Other</MenuItem>

                    </TextField>
                </Box>

                {/* Conditional Textarea for "Other" */}
                {reason === "other" && (
                    <Box mb={2}>
                        <TextField
                            label="Please specify"
                            multiline
                            rows={3}
                            fullWidth
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            placeholder="Enter your reason for return..."
                        />
                    </Box>
                )}

                {/* Image Upload */}
                <Box mb={2}>
                    <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{
                            py: 1,
                            fontSize: "0.8125rem",
                            textTransform: "none",
                            minHeight: "36px",
                        }}
                        startIcon={<UploadFile fontSize="small" />}
                    >
                        Upload Images
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onChange={handleImageUpload}
                        />
                    </Button>
                </Box>

                {/* Image Previews */}
                {previewImages.length > 0 && (
                    <Grid container spacing={1}>
                        {previewImages.map((img, index) => (
                            <Grid item key={index} position="relative">
                                <img
                                    src={img}
                                    alt={`preview-${index}`}
                                    style={{
                                        width: 80,
                                        height: 80,
                                        objectFit: "cover",
                                        borderRadius: 4,
                                        border: "1px solid #ccc",
                                    }}
                                />
                                <Button
                                    size="small"
                                    onClick={() => handleRemoveImage(index)}
                                    sx={{
                                        position: "absolute",
                                        top: -8,
                                        right: -8,
                                        minWidth: 0,
                                        padding: "2px",
                                        borderRadius: "50%",
                                        backgroundColor: "#ef4444",
                                        color: "white",
                                        "&:hover": { backgroundColor: "#dc2626" },
                                    }}
                                >
                                    X
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </DialogContent>
            {/* Footer Buttons (center aligned) */}
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button onClick={handleCancle} variant="outlined">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ backgroundColor: "#ef4444" }}
                >
                    {order?.returnLoading ? (
                        <CircularProgress
                            size={20}
                            sx={{
                                color: "#374151",
                            }}
                        />
                    ) : (
                        "Submit"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
